// extracted by mini-css-extract-plugin
export var buttonWrapper = "CodeArea-module--buttonWrapper--Vjxzn";
export var button = "CodeArea-module--button--AWZ2D";
export var codeLink = "CodeArea-module--codeLink--2VOvA";
export var copyButton = "CodeArea-module--copyButton--hlR5e";
export var active = "CodeArea-module--active--SL5FI";
export var linkToSandBox = "CodeArea-module--linkToSandBox--GUUyV";
export var wrapper = "CodeArea-module--wrapper--N6VkZ";
export var showCode = "CodeArea-module--showCode--e4jec";
export var liveRunnerWrapper = "CodeArea-module--liveRunnerWrapper--CjZ9k";
export var liveRunner = "CodeArea-module--liveRunner--Hg-T2";